// extracted by mini-css-extract-plugin
export var banner = "_37-0";
export var icon = "_37-1";
export var message = "_37-2";